import { render, staticRenderFns } from "./DisputeItem.vue?vue&type=template&id=11e9031d&scoped=true&"
import script from "./DisputeItem.vue?vue&type=script&lang=js&"
export * from "./DisputeItem.vue?vue&type=script&lang=js&"
import style0 from "./DisputeItem.vue?vue&type=style&index=0&id=11e9031d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e9031d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
